export default __webpack_public_path__ + "static/screen_4-b981552738fe6c9600521f938d94b909.jpeg";